import PayWithPointsButton from "../methods/PayWithPointsButton";
import BackButton from "../ui/BackButton";

export default function PointsStep({
  itemId,
  onBack,
}: {
  itemId: number;
  onBack: () => void;
}) {
  return (
    <div className="space-y-4 animate-slideIn">
      <PayWithPointsButton itemId={itemId} onSuccess={() => {}} />
      <BackButton onClick={onBack} />
    </div>
  );
}